import type { FC } from 'react';
import { Button, Flex } from '@/uicomponents';
import { WarningPanel } from '@/components/shared';

export interface RecoveryBannerProps {
  open: boolean;
  onApply: () => void;
  onDiscard: () => void;
}

export const RecoveryBanner: FC<RecoveryBannerProps> = ({ open, onApply, onDiscard }) => {
  if (!open) return null;
  return (
    <WarningPanel
      title='Recover unsaved changes?'
      actions={
        <Flex gap={8}>
          <Button size='small' type='primary' onClick={onApply}>
            Apply
          </Button>
          <Button size='small' onClick={onDiscard}>
            Discard
          </Button>
        </Flex>
      }
    >
      We found edits that didn&apos;t sync last time.
    </WarningPanel>
  );
};
